var map = {
	"./apotheorasislogo.png": 5878,
	"./apotheorasisroundedlogo.png": 4841,
	"./contactMailDark.svg": 9812,
	"./developerActivity.svg": 9504,
	"./discordlogo.jpg": 3890,
	"./facebookLogo.png": 6282,
	"./feelmefeelmenotroundedlogo.png": 5328,
	"./feelmefeelnotlogo.png": 19,
	"./gdalogo.png": 3976,
	"./googleAssistant.svg": 9650,
	"./iekintergraphicslogo.png": 9072,
	"./images-removebg-preview.png": 9106,
	"./jsFramework.svg": 4406,
	"./konstantinos-vasileiadis.png": 1615,
	"./konvasrounded.png": 1818,
	"./lilarenalogo.png": 7269,
	"./lilarenaroundedlogo.png": 1533,
	"./manOnTable.svg": 3350,
	"./monstermopuplogo.png": 3919,
	"./programmer.svg": 2075,
	"./saeLogo.png": 6323,
	"./skill.svg": 1262,
	"./talksCardBack.svg": 7175,
	"./tall-guy-productions-logo-dark.png": 906,
	"./tallguylogo.png": 6492,
	"./terahard_logo.png": 5950,
	"./umcrest.png": 2416,
	"./uniofpatras.png": 7397,
	"./wolfhowlanim.svg": 3134
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2293;